import api from '@pray/shared/utils/api';

/* eslint-disable camelcase */
type AdminCreditTransactionRequest = {
  credits: number;
  transaction_type: 'add' | 'subtract';
  description: string;
  expires_at?: string;
};

type AdminCreditTransactionProps = {
  artistId: string;
  credits: number;
  transactionType: 'add' | 'subtract';
  description: string;
  expiresAt: string | null;
};

export const createAdminTransaction = async ({
  artistId,
  credits,
  transactionType,
  description,
  expiresAt,
}: AdminCreditTransactionProps) => {
  if (!artistId) throw Error('Artist ID is required');
  if (!credits || credits <= 0) throw Error('Credits must be a positive number');
  if (!transactionType || !['add', 'subtract'].includes(transactionType)) {
    throw Error('Transaction type must be "add" or "subtract"');
  }
  if (!description) throw Error('Description is required');

  const url = `/web/studio/artists/${artistId}/credits/balance`;

  const payload: AdminCreditTransactionRequest = {
    credits,
    transaction_type: transactionType,
    description,
  };

  if (expiresAt) {
    payload.expires_at = expiresAt;
  }

  await api.executePostRequest(url, payload);
};
